import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";

const useStyles = makeStyles(theme => ({
	root: {
		flexGrow: 1
	},
	paper: {
		padding: theme.spacing(2),
		textAlign: "center",
		color: theme.palette.text.secondary
	}
}));

export default function CenteredGrid() {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<Grid container spacing={3}>
				<Grid item xs={6}>
					<Paper className={classes.paper}>
						<div
							className="video"
							style={{
								position: "relative",
								paddingBottom: "56.25%" /* 16:9 */,
								paddingTop: 25,
								height: 0
							}}
						>
							<iframe
								style={{
									position: "absolute",
									top: 0,
									left: 0,
									width: "100%",
									height: "100%"
								}}
								src={`https://www.youtube.com/embed/TktL3QR8Yg8`}
								frameBorder="0"
							/>
						</div>
					</Paper>
				</Grid>
				<Grid item xs={6}>
					<Paper className={classes.paper}>
						<div
							className="video"
							style={{
								position: "relative",
								paddingBottom: "56.25%" /* 16:9 */,
								paddingTop: 25,
								height: 0
							}}
						>
							<iframe
								style={{
									position: "absolute",
									top: 0,
									left: 0,
									width: "100%",
									height: "100%"
								}}
								src={`https://www.youtube.com/embed/TktL3QR8Yg8`}
								frameBorder="0"
							/>
						</div>
					</Paper>
				</Grid>
			</Grid>
		</div>
	);
}
